import { render, staticRenderFns } from "./InputId.vue?vue&type=template&id=c64b1bfe&"
import script from "./InputId.vue?vue&type=script&lang=js&"
export * from "./InputId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports